import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Info } from "lucide-react";
import { useSeo } from "../components/site/Layout";
import { CtaBand, AidNotice } from "../components/site/blocks";
import { api } from "../lib/api";
import { formatDate } from "./Ressources";
import NotFound from "./NotFound";

const Block = ({ b }) => {
  if (b.type === "h2") return <h2 className="mt-12 mb-4 text-2xl sm:text-3xl">{b.text}</h2>;
  if (b.type === "p") return <p className="mb-5 text-lg text-slate-700 leading-relaxed">{b.text}</p>;
  if (b.type === "ul" || b.type === "ol") {
    const Tag = b.type;
    return <Tag className={`mb-6 space-y-2 pl-6 text-lg text-slate-700 ${b.type === "ul" ? "list-disc" : "list-decimal"} marker:text-brand-ink`}>{b.items.map((i) => <li key={i}>{i}</li>)}</Tag>;
  }
  if (b.type === "note") return <p className="my-8 flex gap-3 rounded-2xl bg-mist p-5 text-slate-800 border-l-4 border-brand"><Info className="h-6 w-6 text-brand-ink shrink-0" aria-hidden="true" />{b.text}</p>;
  if (b.type === "table") return (
    <div className="mb-8 overflow-x-auto rounded-xl border border-navy/10">
      <table className="w-full min-w-[480px] text-left">
        <thead><tr className="bg-mist text-navy">{b.head.map((h) => <th key={h} className="p-3">{h}</th>)}</tr></thead>
        <tbody>{b.rows.map((r) => <tr key={r[0]} className="border-t border-navy/10">{r.map((c, i) => <td key={i} className={`p-3 ${i ? "text-slate-700" : "font-semibold text-navy"}`}>{c}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
  return null;
};

export default function ArticlePage() {
  const { slug } = useParams();
  const [a, setA] = useState(undefined);
  useEffect(() => { api.get(`/articles/${slug}`).then((r) => setA(r.data)).catch(() => setA(null)); }, [slug]);
  useSeo(a?.title || "Ressources", a?.excerpt);
  if (a === null) return <NotFound />;
  if (!a) return <div className="container-x py-24 text-slate-600">Chargement…</div>;
  return (
    <>
      <article data-testid="article-detail">
        <header className="bg-mist">
          <div className="container-x py-12 md:py-16 max-w-4xl">
            <Link to="/ressources" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-brand-ink" data-testid="article-back-link"><ArrowLeft className="h-5 w-5" aria-hidden="true" /> Toutes les ressources</Link>
            <p className="eyebrow mt-8">{a.category}</p>
            <h1 className="mt-4 text-4xl sm:text-5xl leading-tight">{a.title}</h1>
            <p className="mt-5 text-lg text-slate-700">{a.excerpt}</p>
            <p className="mt-4 text-sm text-slate-600">Publié le {formatDate(a.published_at)} · {a.reading_time} min de lecture</p>
          </div>
        </header>
        <div className="container-x max-w-4xl -mt-2 pt-10">
          <img src={a.image} alt="" className="w-full aspect-[16/8] object-cover rounded-[24px]" />
        </div>
        <div className="container-x max-w-3xl py-12">
          {a.body.map((b, i) => <Block key={i} b={b} />)}
          <AidNotice className="mt-10" />
        </div>
      </article>
      <CtaBand />
    </>
  );
}
